<template>
  <GcBaseLayout
    :title="'Production Schedule'"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="false"
    :backButtonFunction="undefined"
    :formsConfig="formsConfig"
    :tabs="getTabs"
    :selectedIndex="selectedTabIndex"
    ref="gc-base-layout"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Production Schedule'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="'Production Schedule'"
        :secondaryLabel="undefined"
      />
    </template>

    <div class="gc-syncfusion production-calendar">
      <div class="main-content" v-if="loaded">
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <div class="button-toolbar">
              <div>
                <DxButton
                  text="Add New"
                  type="default"
                  styling-mode="contained"
                  class="button-full-width margin-right-5 override-styles"
                  icon="plus"
                  width="75"
                  :visible="getPermissionToCreate"
                  @click="addNewWorkOrder()"
                />
              </div>
              <div>
                <DxButton
                  type="normal"
                  styling-mode="contained"
                  class="button-full-width override-styles"
                  icon="filter"
                  width="30"
                  v-if="!showRightContainer"
                  @click="openFilterPanel()"
                />
              </div>
            </div>
            <ejs-schedule
              :id="'ejs-schedule'"
              :height="height"
              :width="width"
              :views="views"
              :showQuickInfo="isTablet"
              :selectedDate="selectedDate"
              :eventSettings="getEventSettings"
              :popupOpen="onPopupOpen"
              :eventClick="onEventClick"
              :dragStart="onDragStart"
              :dragStop="onDragStop"
              ref="ejs-schedule-ref"
              :timeScale="{
                enable: false,
              }"
            >
              <!-- main tile template  -->
              <template v-slot:eventTemplate="{ data }">
                <div class="template-wrap event-template">
                  <div class="subject">WO - {{ data.subject }}</div>
                  <div class="description">
                    {{ data.ProductCode }}
                  </div>
                  <div class="time">
                    Planned Qty - {{ getFormattedQty(data.RequiredQty) }}
                    {{ data.StockUM }}
                  </div>
                </div>
              </template>

              <!-- tooltip template  -->
              <template v-slot:tooltipTemplate="{ data }">
                <div class="template-wrap">
                  <div class="subject">WO - {{ data.subject }}</div>
                  <div class="description">
                    {{ data.ProductCode }} - {{ data.ProductDescription1 }}
                  </div>
                  <div class="time">
                    Planned Qty - {{ getFormattedQty(data.RequiredQty) }}
                    {{ data.StockUM }}
                  </div>
                </div>
              </template>
            </ejs-schedule>
          </template>
          <template #rightContent>
            <gc-filter-panel
              :toolbarVisible="true"
              :toolbar="filterToolbar"
              :formItemData="filterFormItems"
              :setGridPanelFilter="setGridPanelFilter"
              :gridFoolter="false"
              :showLoading="showLoading"
              :from="'transaction-screen'"
              :isNormal="false"
              :persistenceKey="undefined"
              :key="'fp-call-schedule'"
              :overWriteClear="true"
              :ref="'gc-filter-panel'"
            >
            </gc-filter-panel>
          </template>
        </gc-filter-split-view>
      </div>

      <GcPopUpWorkOrder
        :popupConfig="popupConfig"
        :on-hide="onPopupHide"
        :wrapper-attr="{
          class: 'css-v2 gc-popup gc-popup-form gc-popup-work-order',
        }"
        :data-model="dataModel"
        :show-loading="showLoading"
        :width="1024"
        :height="370"
        :save-call-back="onWorkOrderSave"
        :displayServerError="displayServerError"
        v-if="popupConfig.isPopupShow"
      />
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  DragAndDrop,
} from "@syncfusion/ej2-vue-schedule";

import { ProductionCalendarService } from "../../_services/api/production/production-calendar.service";
import { getCalendarFilterValues } from "../../_helpers/calendar/filter-panel";

import { DataManager, ODataV4Adaptor } from "@syncfusion/ej2-data";
import { FeatureStorage, TokenStorage } from "../../_services/storage";
import appConfig from "../../app-config";
import { WorkOrderService } from "@/_services/api/production/work-order.service";
import { formatNumber } from "devextreme/localization";

class CustomAdaptor extends ODataV4Adaptor {
  processResponse() {
    let original = super.processResponse.apply(this, arguments);

    original.forEach((item) => {
      item.subject = item.WorkOrderCode;
      item.startTime = new Date(item.ScheduledDate);
      item.endTime = new Date(item.ScheduledDate).addGMTHours(undefined, 5);
      item.IsAllDay = true;
    });

    return original;
  }
}
export default {
  mixins: [RouteMixin, FormMixin],
  provide: {
    schedule: [Day, Week, WorkWeek, Month, Agenda, DragAndDrop],
  },
  data() {
    return {
      tabInfo: [],
      selectedIndex: 0,
      showLeftContainer: true,
      showRightContainer: true,
      loaded: false,
      height: "auto",
      width: "100%",
      views: ["Day", "Week", "WorkWeek", "Month"],
      selectedDate: new Date(),
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
          },
        },
      },
      filterValues: false,
      ProcessCode: undefined,
      popupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        toolbarMenuItems: [
          {
            menuText: "Copy",
            visible: false, // pending discussions #54331
          },
          { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler },
          { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
          { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },
        ],
        formMode: "create",
        isEditable: false,
        calendarDate: undefined,
        workOrderCode: undefined,
      },
      dataModel: undefined,
    };
  },
  async beforeCreate() {
    await ProductionCalendarService.getProductionProcess().then((res) => {
      res.data.value.forEach((element) => {
        this.tabInfo.push({
          code: element.Code,
          text: element.Description,
          path: `/production-calendar/` + element.Code,
          applicationFeatureCode: "ProductionSchedule",
          onClick: this.onProcessChanged,
        });
      });
    });

    if (this.baseView.id) {
      let index = this.tabInfo.findIndex((x) => x.code === this.baseView.id);
      if (index !== -1) this.selectedIndex = index;
      this.ProcessCode = this.baseView.id;
    } else {
      this.ProcessCode = this.tabInfo[0].code;
    }
  },
  mounted() {
    setTimeout(() => {
      var scrollableView = document.getElementsByClassName(
        "layout-body dx-scrollview"
      );

      this.height = scrollableView[0].clientHeight - 65;
    }, 250);
  },
  async created() {
    this.loaded = true;
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    /**
     * Open Filter Panel
     */
    openFilterPanel() {
      this.showRightContainer = true;
    },
    /**
     * Filter Panel values
     * @param e
     * @param valueChanged
     */
    setGridPanelFilter(e, valueChanged) {
      this.filterValues = getCalendarFilterValues(e, valueChanged);
    },

    /**
     * dynamic tab value changed
     */
    onProcessChanged(e) {
      if (e && this.ProcessCode !== e.code) {
        this.showLoading(true);
        let scheduleObj =
          document.getElementById("ejs-schedule").ej2_instances[0];

        if (scheduleObj) {
          this.filterValues = undefined;
          this.$refs["gc-filter-panel"].$refs["gc-form"].clearFormModel();
          //   scheduleObj.refresh();
          this.$nextTick(() => {
            this.ProcessCode = e.code;
            setTimeout(() => {
              this.showLoading(false);
            }, 500);
          });
        } else this.showLoading(false);
      }
    },

    /**
     * on default popup open event
     * @param args
     */
    async onPopupOpen(args) {
      if (args.type === "Editor") {
        args.cancel = true;

        this.popupConfig.title = "Create Work Order";
        this.popupConfig.hideOnOutsideClick = false;
        this.popupConfig.workOrderCode = undefined;
        this.popupConfig.formMode = "create";
        await this.showEventCreateOrEditModal(args, args.data);
      }
    },

    /**
     * on event click event - by default event
     * @param args
     */
    async onEventClick(args) {
      if (args.name === "eventClick") {
        args.cancel = true;
        this.showLoading(true);

        let data = (this.dataModel = args.event);

        this.popupConfig.formMode = "review";
        this.popupConfig.hideOnOutsideClick = true;
        this.popupConfig.workOrderCode = data.WorkOrderCode;

        this.popupConfig.title = `Work Order #${data.WorkOrderCode}`;
        this.popupConfig.secondaryTitle =
          data.ProductCode + " - " + data.ProductDescription1;
        this.popupConfig.isEditable =
          (data.FriendlyStatus === "Active" ||
            data.FriendlyStatus === "In Production") &&
          FeatureStorage.checkPermission("WorkOrder", "edit");

        const response = await WorkOrderService.getByCode(
          this.popupConfig.workOrderCode
        );
        this.dataModel = response.data.value[0];
        this.popupConfig.isPopupShow = true;

        // await this.showEventCreateOrEditModal(args, args.event);
      }
    },

    /**
     * on drag starts event
     */
    onDragStart(e) {
      if (
        this.getPermissionToCreate == false ||
        e.data.FriendlyStatus !== "Active"
      )
        e.cancel = true;
    },

    /**
     * on drag stop event
     */
    async onDragStop(e) {
      e.cancel = true;
      if (e.data) {
        this.showLoading(true);
        var model = e.data;
        // update single event
        let payload = {
          ProcessCode: this.ProcessCode,
          ScheduledDate: new Date(model.startTime).toSaveDate(),
          WorkOrderCode: model.WorkOrderCode,
          Comments: model.Comments,
        };

        await WorkOrderService.workOrderReschedule(payload)
          .then((res) => {
            if (res) this.showLoading(false);
            this.$notify(
              `Work order #${model.WorkOrderCode} is successfully updated.`,
              "success"
            );
            this.onWorkOrderSave();
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.displayServerError(err);
          });
      }
    },

    /**
     * add new WO event
     */
    addNewWorkOrder() {
      let scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];

      let cellData = {
        data: {
          startTime: new Date(),
        },
        type: "Editor",
      };
      scheduleObj.popupOpen(cellData, "Editor");
    },

    async showEventCreateOrEditModal(args, eventData) {
      args.cancel = true;
      if (eventData) {
        if (this.getPermissionToCreate === false) args.cancel = true;
        else {
          this.dataModel = {
            StartDate: eventData.startTime,
          };

          this.popupConfig.calendarDate = eventData.startTime;
          this.popupConfig.isPopupShow = true;
        }
      }
    },
    /**
     * Hide A popup
     */
    onPopupHide() {
      this.popupConfig.isPopupShow = false;
    },

    onWorkOrderSave() {
      this.onPopupHide();
      this.showLoading(true);
      let scheduleObj =
        document.getElementById("ejs-schedule").ej2_instances[0];

      if (scheduleObj) {
        scheduleObj.refresh();
        this.$nextTick(() => {
          setTimeout(() => {
            this.showLoading(false);
          }, 500);
        });
      } else this.showLoading(false);
    },
  },
  computed: {
    /**
     * Return user permission for the feature
     */
    getPermissionToCreate() {
      return FeatureStorage.checkPermission("WorkOrder", "create");
    },
    /**
     * Return event settings
     */
    getEventSettings() {
      return {
        dataSource: this.getDataManager,
        fields: {
          id: "Id",
          subject: { name: "subject" },
          description: { name: "Purpose" },
          startTime: { name: "startTime" },
          endTime: { name: "endTime" },
        },
        enableTooltip: true,
        template: "eventTemplate",
        tooltipTemplate: "tooltipTemplate",
      };
    },

    /**
     * returns the datasource manager for the scheduler
     */
    getDataManager() {
      if (this.filterValues == undefined || this.ProcessCode == undefined)
        return;
      let dataManager = new DataManager({
        url:
          appConfig.VUE_APP_ROOT_API +
          `/api/ProductionScheduleWorkOrder?${
            this.filterValues
              ? `&filter=${this.filterValues} and (ProcessCode eq '${this.ProcessCode}')`
              : `&filter=(ProcessCode eq '${this.ProcessCode}')`
          }`,
        adaptor: new CustomAdaptor(),
        crossDomain: true,
      });

      dataManager.adaptor.beforeSend = function (dm, request) {
        request.setRequestHeader("x-tenant-id", TokenStorage.getTenant());
        request.setRequestHeader(
          "Authorization",
          `Bearer ${TokenStorage.getToken()}`
        );
      };

      return dataManager;
    },

    /**
     * Retun filter panel form items
     */
    filterFormItems() {
      return [
        {
          screenField: "Code",
          filterLabel: "Work Order",
          filterDataField: "WorkOrderCode",
          //   dataType: "Integer",
          type: "Integer",
        },
        {
          screenField: "Product",
          filterDataField: "ProductCode",
        },
        {
          screenField: "BOM",
          filterDataField: "BomCode",
        },
        {
          screenField: "Status",
          filterDefaultValue: ["Active", "In Production"],
          filterDataField: "FriendlyStatus",
          dataSourceConfig: {
            data: [
              { key: "Active", value: "Active" },
              { key: "Cancelled", value: "Cancelled" },
              { key: "Completed", value: "Completed" },
              { key: "In Production", value: "In Production" },
            ],
          },
        },
      ];
    },

    /**
     * return tab value
     */
    getTabs() {
      return this.tabInfo;
    },

    /**
     * return selected tab index
     */
    selectedTabIndex() {
      return this.selectedIndex;
    },
  },
};
</script>

<style lang="scss">
.production-calendar {
  // .event-template {
  //   .description {
  //     text-wrap: wrap;
  //   }
  // }

  // .e-schedule .e-vertical-view.e-timescale-disable .e-appointment {
  //   height: auto !important;
  // }

  .e-schedule .e-month-view .e-current-date .e-date-header,
  .e-calendar .e-content td.e-selected span.e-day,
  .e-bigger.e-small .e-calendar .e-content td.e-selected span.e-day {
    background-color: #03a9f4 !important;
    border: 1px solid #03a9f4;
  }

  .e-btn.e-flat.e-primary,
  .e-css.e-btn.e-flat.e-primary,
  .e-active-view .e-tbar-btn-text,
  .e-current-day {
    color: #03a9f4 !important;
  }

  .e-schedule .e-month-view .e-appointment,
  .e-schedule .e-vertical-view.e-timescale-disable .e-appointment {
    background-color: #03a9f4 !important;
  }
}
</style>
